angular.module('common')
    .controller("loginController", ['authFactory', 'localStorageService', '$window', function (authFactory, localStorageService, $window) {
        function LoginController(authFactory, localStorageService, $window) {
            var self = this;
            self.window = $window;
            self.authFactory = authFactory;
            self.localStorageService = localStorageService;
            self.userName = null;
            self.password = null;
            self.btnText = "Login";
            self.btnDisabled = false;
            self.maskedNumber = null;
            self.code = null;
            self.twoFactorOn = null;
            self.action = self.init2ndFactor;
            self.loadTwoFactorConfig();
        }

        LoginController.prototype.loadTwoFactorConfig = function () {
            var self = this;
            self.authFactory.getTwoFactorConfig()
                .success(function (response) {
                    self.twoFactorOn = response === "true";
                }).error(function (err) {
                    self.onError(err.ExceptionMessage, "Login");
                });
        }

        LoginController.prototype.onError = function (errMsg, btnText) {
            var self = this;
            self.btnDisabled = false;
            self.btnText = btnText;
            $.message(errMsg, MessageType.Error);
        }

        LoginController.prototype.init2ndFactor = function () {
            var self = this;
            self.btnDisabled = true;
            self.btnText = "Connecting, please wait...";
            self.authFactory.init2ndFactor({ username: self.userName, password: self.password })
                .success(function (response) {
                    self.btnDisabled = false;
                    self.btnText = "Verify Code";
                    self.maskedNumber = JSON.parse(response).replace(/\"/g, "");
                    self.action = self.verify2ndFactor;
                }).error(function (err) {
                    self.onError(JSON.parse(err).replace(/\"/g, ""), "Login");
                });
        }

        LoginController.prototype.verify2ndFactor = function () {
            var self = this;
            self.btnDisabled = true;
            self.btnText = "Connecting, please wait...";
            self.authFactory.verify2ndFactor({ username: self.userName, password: self.password, code: self.code })
                .success(function (response) {
                    self.login();
                }).error(function (err) {
                    self.onError(JSON.parse(err).replace(/\"/g, ""), "Verify Code");
                });
        }

        LoginController.prototype.login = function () {
            var self = this;
            var credentials = "grant_type=password&username=" + self.userName + "&password=" + self.password;
            self.btnText = "Connecting, please wait...";
            self.btnDisabled = true;
            self.authFactory.login(credentials)
                .success(function (response) {
                    self.authFactory.getUserWithCreds(response.access_token, credentials)
                        .success(function (res) {
                            self.localStorageService.storeUserData(response, self.userName, res.IsAdmin, res.IsTechSuper, res.CredsKey);
                            self.window.location.href = "/";
                        })
                        .error(function (err) {
                            self.onError(err.error_description, "Login");
                        });

                }).error(function (err) {
                    self.onError(err.error_description, "Login");
                });
        };

        return new LoginController(authFactory, localStorageService, $window);
    }]);
